import { ProbateDetails } from "../models/ProbateDetails";
import { network } from "./index";
import { ProbateField } from "../models/ProbateField";
import { AtticusForm } from "../models/AtticusForm";
import { CognitoAuth } from "./CognitoAuth";

export class ProbateAPI {
  async getProbateDetails(
    estateId: number,
    queryString?: string
  ): Promise<ProbateDetails | undefined> {
    try {
      let path = `/estates/{estateId}/determine-probate-type`;
      if (queryString) path += `?${queryString}`;
      const response = await network.callGet(path, true);
      return ProbateDetails.fromJSON(response?.data);
    } catch (error) {
      CognitoAuth.handleError(error, "getProbateDetails error");
    }
  }

  async saveFieldToKnowledgeEngine(
    field: ProbateField,
    rethrowError = false
  ): Promise<any | undefined> {
    try {
      if (field?.id) {
        const path = `/knowledge-engine/field-answer/${field.id}`;
        return await network.callPost(
          path,
          {
            answer_value: field.answerValue,
          },
          rethrowError
        );
      } else {
        throw new Error("field id unknown");
      }
    } catch (error) {
      CognitoAuth.handleError(error, "saveFieldToKnowledgeEngine error");
    }
  }

  /**
   * will delete knowledge engine answers for this estate
   * @param field
   * @param rethrowError
   */
  async deleteFieldsInKnowledgeEngine(
    field: ProbateField | string,
    rethrowError = false
  ): Promise<any | undefined> {
    try {
      if (field instanceof ProbateField) {
        // NOTE: this is currently not supported by the laravel api
        if (field?.id) {
          const path = `/knowledge-engine/field-answer/${field.id}`;
          return await network.callPost(
            path,
            {
              answer_value: field.answerValue,
            },
            rethrowError
          );
        } else {
          throw new Error("field id unknown");
        }
      } else if (field === "all") {
        const path = `/knowledge-engine/field-answer/all`;
        return await network.callDelete(path, rethrowError);
      } else {
        throw new Error("delete operation unsupported");
      }
    } catch (error) {
      CognitoAuth.handleError(error, "deleteFieldInKnowledgeEngine error");
    }
  }

  async getProbatePacket(): Promise<AtticusForm[] | undefined> {
    try {
      const path = `/estates/first/probate-packet`;
      const packetResponse = await network.callGet(path, true);
      return packetResponse?.data?.map((json: any) =>
        AtticusForm.fromJSON(json)
      );
    } catch (error) {
      // NOTE: intentionally not signing out when 401 is returned
      return undefined;
    }
  }
}
